import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DsRadioGroupComponent } from "./ds-radio-group.component";
import { MatRadioModule } from "@angular/material/radio";
import { DsRadioButtonModule } from "../ds-radio-button/ds-radio-button.module";

@NgModule({
  declarations: [DsRadioGroupComponent],
  imports: [CommonModule, FormsModule, MatRadioModule, DsRadioButtonModule],
  exports: [DsRadioGroupComponent],
})
export class DsRadioGroupModule {}
